
import { Notification, KIND } from "baseui/notification";
import {
  ParagraphXSmall,
} from 'baseui/typography';
import { useStyletron } from 'baseui';
import { DeleteObjectButton } from './components/DeleteObjectButton'

export function UnknownAutomationObject(props: any) {
  const [css] = useStyletron();
  const revertLineHeight = {
    Block: {
      style: ({ $theme }: any) => ({
        marginBlockStart: '0',
        marginBlockEnd: '0',
      })
    }
  }
  return (
    <div className={css({
      style: {
        width: 'auto'
      }
    })}>
      <Notification kind={KIND.warning} overrides={{
        Body: {
          style: ({ $theme }: any) => ({
            width: 'auto',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
          })
        }
      }}>
        {() => (<>
          Unknown or not implemented object type.
          <ParagraphXSmall overrides={revertLineHeight}>ObjectID: {props.id}</ParagraphXSmall>
          <ParagraphXSmall  overrides={revertLineHeight}>Name: {props.name}</ParagraphXSmall>
          <ParagraphXSmall  overrides={revertLineHeight}>Schema: {props.schema}</ParagraphXSmall>
        </>)
        }
      </Notification>
      <DeleteObjectButton objectName={props.name} objectId={props.id}></DeleteObjectButton>
    </div>
  )
}